import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import Reducers from "./reducers-config";
import sagaConfig from "./saga-config";

export const NODE_ENV_DEVELOPMENT = "development";
const sagaMiddleware = createSagaMiddleware();

let composeEnhancers = compose;

if (process.env.NODE_ENV.trim() === NODE_ENV_DEVELOPMENT) {
  composeEnhancers = globalThis.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
}

export default createStore(Reducers, undefined, composeEnhancers(applyMiddleware(sagaMiddleware)));

sagaMiddleware.run(sagaConfig);
